/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, Modal } from 'antd'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { PropertyHandlers } from '../../PropertyComp/state/actions'
import { toolsAction } from '../../Tools/state/actions'
import { formatBaseName } from '../utils/extraFunctions'

const EditNameModal = ({ nestedModalOpen, setNestedModalOpen, form, origin, agentDetails, delegate }) => {

    const [isBtnDisabled, setIsBtnDisabled] = useState(true);

    const dispatch = useDispatch()

    const handleCancel = () => {
        setNestedModalOpen({ ...nestedModalOpen, isEditNameModalOpen: false, editDocDetails: {} })
        setIsBtnDisabled(true);
    }

    const delegateOwnerId = delegate ? agentDetails?._id : null;
    const delegateSide = (nestedModalOpen?.editDocDetails?.isProperty || nestedModalOpen?.editDocDetails?.isErts) ? "SELLER" : "BUYER";

    const handleEditNameSave = (values) => {
        
        let urlData = {
            updatedName: values?.editedName,
            ...(nestedModalOpen?.editDocDetails?.isResureSignDoc
              ? {
                  offerDoc: false,
                  isResureSignDoc: true,
                }
              : nestedModalOpen?.editDocDetails?.contractId
              ? {
                  offerDoc: true,
                }
              : {
                  offerDoc: false,
                }),
          };

        if (origin === "propertyDocs" || origin === "contacts") {
            dispatch(PropertyHandlers.changeDocName({ urlData, documentId: nestedModalOpen?.editDocDetails?._id,
                ...(delegateOwnerId && nestedModalOpen?.editDocDetails?.isResureSignDoc ? { delegateOwnerId } : {}),
                ...(delegateSide && nestedModalOpen?.editDocDetails?.isResureSignDoc ? { delegateSide } : {}),
             }))
        } else if (origin === "toolsOtherDocs") {
            dispatch(toolsAction.changeOtherDocName({ urlData, documentId: nestedModalOpen?.editDocDetails?._id }))
        }

        handleCancel()
    }

    const handleValuesChange = (_, allValues) => {
        const originalName = nestedModalOpen?.editDocDetails?.updatedName  || formatBaseName(nestedModalOpen?.editDocDetails)
        const currentVal = allValues?.editedName?.trim();
        setIsBtnDisabled(currentVal === originalName.trim());
      };

    useEffect(() => {
        form?.setFieldsValue({ editedName: nestedModalOpen?.editDocDetails?.updatedName || formatBaseName(nestedModalOpen?.editDocDetails) })
    }, [nestedModalOpen?.isEditNameModalOpen, nestedModalOpen?.editDocDetails])

    return (
      <>
        <Modal open={nestedModalOpen?.isEditNameModalOpen} onCancel={handleCancel} title={<span className="commonModalTitle">Edit Name</span>} footer={false}>
          <Form form={form} initialValues={{ editedName: nestedModalOpen?.editDocDetails?.updatedName || formatBaseName(nestedModalOpen?.editDocDetails) }} onValuesChange={handleValuesChange} onFinish={handleEditNameSave}>
            <Form.Item label="Name" name="editedName">
              <Input></Input>
            </Form.Item>
            <Form.Item>
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <Button type="primary" htmlType="submit" disabled={isBtnDisabled}>
                  Save
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
}

export default EditNameModal
